export default __webpack_public_path__ + "static/media/AntyLucy_17.5a157fb7.jpg";